import React from "react";
import { Navigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const FullScreenLoader = () => (
  <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="app-loader">
    <div className="flex flex-col items-center gap-3">
      <div className="flex h-12 w-12 animate-pulse items-center justify-center rounded-xl bg-primary text-primary-foreground">
        <Compass className="h-6 w-6" />
      </div>
      <p className="text-sm text-muted-foreground">Cargando SOFI 2.0…</p>
    </div>
  </div>
);

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, me } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!me) return <FullScreenLoader />;
  return children;
}
